window.paceOptions = {
    ajax: {
        ignoreURLs: ['hotjar.com', 'driftt.com'],
    },
};

import 'pace-js';

